import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "button"]

  connect() {
    // Sync input disabled state from button selected state on connect
    this.inputTargets.forEach(input => {
      const button = this.element.querySelector(`[data-value="${input.dataset.key}"]`)
      if (button) {
        input.disabled = !button.classList.contains("selected")
      }
    })
  }

  toggle(event) {
    const button = event.currentTarget
    const value = button.dataset.value
    const input = this.inputTargets.find(i => i.dataset.key === value)

    if (!input) {
      console.error("No input found for key:", value)
      return
    }

    if (button.classList.contains("selected")) {
      button.classList.remove("selected")
      input.disabled = true
    } else {
      button.classList.add("selected")
      input.disabled = false
    }
  }
}
